var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ELEMENTS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.126,
    height: 22.786,
    viewBox: "0 0 12.126 22.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M22.221,16.167l.629-4.1H18.916V9.405a2.052,2.052,0,0,1,2.316-2.212h1.784V3.737a21.742,21.742,0,0,0-3.173-.277c-3.235,0-5.358,1.963-5.358,5.531v3.125H10.89v4.1h3.595v9.858a14.712,14.712,0,0,0,2.219.173,14.518,14.518,0,0,0,2.212-.173V16.167Z",
    transform: "translate(-10.89 -3.46)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9987569cba854aa17bdff49411b6abc4.svg";
export { ForwardRef as ReactComponent };